// I used the 'dayjs' library to format the date, please, make sure you install it
import dayjs from "dayjs";
import React, {useState, useEffect} from "react";
import {Container, Row, Col} from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import {Line} from "react-chartjs-2";
import performanceService from "../../services/performance-service";
import StatisticsBoxes from "components/common/StatisticsBoxes";
import {Link} from "react-router-dom";
import "./Performance.css";
import {useDispatch} from "react-redux";
// import { showRegister } from "actions/auth";
import {showRegister} from "actions/ui_control";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

function Performance() {
  // I removed the "labelsLength" state to make the code a little bit clearer
  const [xAxisInterval, setXAxisInterval] = useState("Max");
  const [labels, setLabels] = useState([]);
  const [navData, setNavData] = useState([]);
  const dispatch = useDispatch();

  const cycle = (array, count, offset = 12) => {
    const output = [];
    let index1 = 0;
    let index2 = 0;
    for (var i = 0; i < 12 * count; i++) {
      if (index2 === offset) {
        index1++;
        index2 = 0;
      }
      output.push(array[index1]);
      index2++;
    }
    return output;
  };

  const getDataset = () => {
    if (xAxisInterval === "Max") {
      return navData;
    }

    const intervals = {
      "1Y": 12,
      "6M": 6,
      "3M": 3,
      "1M": 1,
    };

    const count = intervals[xAxisInterval];
    const offset = Math.floor(navData.length / count);

    return cycle(navData, count, offset);
  };
  const calcMaxChartValue = () => {
    const maxNav = Math.max(...navData);
    // How much 'stepSizes' above the max value. E.g valueAboveMax => 100%, divide it by 10 and you get 10% from max val
    const valueAboveMax = maxNav / 20;
    // Maximum value after adding space we want above
    const maxVal = Math.round(maxNav / 1000) * 1000 + valueAboveMax;
    // Check what remains to have a value dividable by 2000 (Which is 'stepSize' we set in options)
    const remainder = (maxVal - 55000) % 2000;
    // add remainder to max value
    const finalMax = maxVal + 2000 - remainder;

    return finalMax;
  };
  const options = {
    responsive: true,
    // disables maintaining only initial size (Makes chart responsible)
    maintainAspectRatio: false,

    plugins: {
      legend: {
        display: false,
      },
    },
    hover: {
      mode: "index",
      intersect: false,
    },
    scales: {
      y: {
        min: 55000,
        //   Get max 'nav' value and add the size you want to have above it (If any)
        max: calcMaxChartValue(),
        position: "right",
        ticks: {
          stepSize: 2000,
          color: "#F8F8F8",
        },
        grid: {
          color: "rgba(76, 75, 86, 0.2)",
        },
      },
      x: {
        ticks: {
          color: "#F8F8F8",

          autoSkip: true,
          maxTicksLimit: navData.length,
        },
        grid: {
          color: "rgba(76, 75, 86, 0.2)",
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        fill: true,
        pointStyle: false,
        label: "",
        data: getDataset(),
        borderColor: "#511281",
        backgroundColor: ({chart: {ctx}}) => {
          const bg = ctx.createLinearGradient(0, 0, 0, 400);
          bg.addColorStop(0, "#51128199");
          bg.addColorStop(1, "#1C193222");
          return bg;
        },
      },
    ],
  };

  const getNavData = async () => {
    try {
      const response = await performanceService.getPerformanceData("/");
      const navData = response.map(item => ({
        date: new Date(item.date).getTime(),
        nav: item.nav,
      }));
      navData.sort((a, b) => a.date - b.date);
      console.log("NAV Data:", navData); // Log the navData to the console
      return navData;
    } catch (error) {
      throw new Error("Error fetching data");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const navData = await getNavData();
        // Added template arrays to push dates to lablesArray and nav data to navData. The code was not working because you was passing array of objects to setNavData() instead of array of "nav" values
        let navDataArray = [];
        let lablesArray = [];

        navData.map(item => {
          const formatedDate = dayjs(item.date).format("MMMM-YY");
          lablesArray.push(formatedDate);
          navDataArray.push(item.nav);
        });
        setNavData(navDataArray);
        setLabels(lablesArray);
      } catch (error) {
        throw new Error("Error fetching data");
      }
    };

    fetchData();
  }, [xAxisInterval]);

  const displayRegister = () => {
    dispatch(showRegister());
  };

  return (
    <>
      {" "}
      <section id="summary-section" className={"mt-5 d-block"}>
        {/* Rendering StatisticsBoxes component and passing to it array containing objects with "title" and "value" variables */}
        <StatisticsBoxes
          arrayOfStatistics={[
            {
              title: "Total DCA Instructions",
              value: 2,
            },
            {title: "Stock total", value: 3},
            {title: "Market Value", value: 4},
          ]}
        />
        <Container className="mt-3">
          <Row className="d-flex justify-content-center justify-content-lg-end">
            <Col className="d-flex justify-content-center">
              <Link
                className="btn btn-dark button-purple-solid btn-xl me-1 me-lg-0"
                onClick={displayRegister}
              >
                Sign Up
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
      <Container className="chart-container mb-5 position-relative">
        {/* Line Chart */}
        <Line options={options} data={data}/>
      </Container>
    </>
  );
}

export default Performance;
